/**
 * Qué cuenta como «esperando su decisión» en el tablero.
 *
 * Lo comparten la lista (DecisionesRapidas) y la página, que con cero
 * pendientes cambia de forma: la lista se vuelve una franja y el equipo toma
 * el ancho entero. Si cada una tuviera su propia lista de tipos, un día una
 * diría «nada pendiente» mientras la otra enseña algo.
 */

/** Se resuelven ahí mismo, con un sí o un no. */
export const DECIDIBLES = new Set([
  'aprobar_cotizacion',
  'mas_tiempo',
  'inicio_sin_ubicacion',
  // 0238: el traslado de herramienta también se decide aquí.
  'traslado_herramienta',
  // 0240: y a quién se manda por una herramienta que pidieron recoger.
  'recogida_herramienta',
])

/** Se revisan en su documento: el botón lleva allá. */
export const IR_AL_DOCUMENTO = new Set(['precierre'])

export function esperaDecision(tipo: string): boolean {
  return DECIDIBLES.has(tipo) || IR_AL_DOCUMENTO.has(tipo)
}
